import { render, staticRenderFns } from "./communicationDashboardNews.vue?vue&type=template&id=5715b830&scoped=true"
import script from "./communicationDashboardNews.vue?vue&type=script&lang=js"
export * from "./communicationDashboardNews.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardNews.vue?vue&type=style&index=0&id=5715b830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715b830",
  null
  
)

export default component.exports